// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"c5fd304f","232":"58cd2900","237":"26c538b1","526":"117d8600","787":"f2252d7e"}[chunkId] + ".chunk.js";
};